import { RootState } from '@/store/types/RootState';

export const selectTaskListPagination = (state: RootState) => state.taskListSlice.pagination;
export const selectTaskList = (state: RootState) => state.taskListSlice.taskList;
export const selectTaskListIsLoading = (state: RootState) => state.taskListSlice.isLoading;
export const selectTaskListSorting = (state: RootState) => state.taskListSlice.sorting;
export const selectTaskListFilters = (state: RootState) => state.taskListSlice.filters;
export const selectTaskListCounters = (state: RootState) => state.taskListSlice.counters;
